module.exports = __webpack_public_path__ + "img/42f79a2814e888829eda61281fad994.7eddc6e5.png";